export { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

export { MessagesMenuComponent } from './top-navbar/messages-menu/messages-menu.component';
export { MessagesMenuService } from './top-navbar/messages-menu/messages-menu.service';

export { NotificationsMenuButtonComponent } from './top-navbar/notifications-menu/button/notifications-menu-button.component';
export { NotificationsMenuContentComponent } from './top-navbar/notifications-menu/content/notifications-menu-content.component';
export { NotificationsMenuService } from './top-navbar/notifications-menu/notifications-menu.service';

export { SearchBarComponent } from './top-navbar/search-bar/search-bar.component';
export { TopNavbarContentComponent } from './top-navbar/content/top-navbar-content.component';

export { CondenseMenuComponent } from './side-menu/condense/condense.component';
export { MenuTopItemsComponent } from './side-menu/top-items/top-items.component';
export { SideMenuContentComponent } from './side-menu/content/side-menu-content.component';
export { SideMenuService } from './side-menu/side-menu.service';

export { Error404PageComponent } from './404/error-404-page.component';
export { Error404PageResolver } from './404/error-404-page.resolver';

export { ResponsiveBreakpointsComponent } from './responsive-breakpoints/responsive-breakpoints.component';
export { ResponsiveBreakpointDirective } from './responsive-breakpoints/responsive-breakpoint.directive';
export { ResponsiveBreakpointsService } from './responsive-breakpoints/responsive-breakpoints.service';

export { CoreModule } from './core.module';



// WEBPACK FOOTER //
// ./src/app/system/core/index.ts